import React from 'react'

import Bolt from 'conversations/svgs/Bolt'
import Minus from 'conversations/svgs/Minus'
import times from 'lodash/times'

import styles from './styles.module.css'

interface Props {
  score?: number
}
const MAX_SCORE = 3

const CQLScore: React.FC<Props> = ({ score }): JSX.Element | null => {
  if (!score) {
    return null
  }
  return (
    <span className={styles.cqlScore}>
      {score >= 0 ? (
        <span className={styles.Bolts}>
          {times(Math.min(score, MAX_SCORE), (index) => (
            <Bolt key={index} width="7" height="12" />
          ))}
        </span>
      ) : (
        <Minus width="12" height="8" />
      )}
    </span>
  )
}

export default CQLScore
